const WLDomparser = (text) => {
  const parser = new DOMParser();
  const htmlDocument = parser.parseFromString(text, 'text/html');
  return htmlDocument;
}
const WLDomRender = (wlDomRender, text, targetElm, target='.js-contents') => {
  console.log(targetElm, targetElm.querySelector(target))
  const htmlDocument = WLDomparser(text);
  const wlDomRenderTemplateElement = htmlDocument.querySelector(target);
  targetElm.querySelector(target).innerHTML = wlDomRenderTemplateElement.innerHTML;
}
const WLCartDomRenderElements = () => {
  return [
    {
      section: 'wl-cart-modal',
      id: document.querySelector('#cart-modal-content').dataset.id,
      target: '.js-contents',
    },
    {
      section: 'header',
      id: document.querySelector('header').dataset.id,
      target: '.cart-count-bubble',
    },
  ]
}

class WLCartModal extends HTMLElement {
  constructor() {
    super();
    for(let closeBtn of this.querySelectorAll('[data-close]')) {
      closeBtn.addEventListener('click', () => this.close());
    }
  }
  close() {
    this.classList.remove('active');
    this.querySelector('.active').classList.remove('active');
    document.querySelector('body').classList.remove('modal-open');
    
    document.body.classList.remove('fixed')
    window.scrollTo(0, parseInt(document.body.style.top.replace('px', '').replace('-', '')));
    document.body.style.overflowY = 'auto'
  }
}
customElements.define('wl-cart-modal', WLCartModal);

class WLQuantityChanger extends HTMLElement {
  constructor() {
    super();
    this.querySelector('.changer.plus').addEventListener('click', () => this.plus(this));
    this.querySelector('.changer.minus').addEventListener('click', () => this.minus(this));
  }
  plus(e) {
    const input = this.querySelector('input');
    const value = parseInt(input.value);
    const max = parseInt(input.max);
    
    if (value < max) {
      input.value = value + 1;
      this.updateItemQuantity(input.dataset.key, input.value);
    }
  }
  minus(e) {
    const input = this.querySelector('input');
    const value = parseInt(input.value);
    const min = parseInt(input.min);
    if (value > min) {
      input.value = value - 1;
      this.updateItemQuantity(input.dataset.key, input.value);
    }
  }
  updateItemQuantity(key, quantity) {
    const data = {
      updates: {
        [key]: quantity
      },
      sections: WLCartDomRenderElements().map((section) => section.id),
      section_url: location.href
    };
    data.updates[key] = quantity;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then((response) => {
      return response.json();
    })
    .then((state) => {
      WLCartDomRenderElements().forEach((wlDomRenderElement) => {
          WLDomRender(wlDomRenderElement.section, state.sections[wlDomRenderElement.section], document.querySelector(`[data-id="${wlDomRenderElement.id}"]`) ,wlDomRenderElement.target);
      });
    });
  }
}
customElements.define('wl-quantity-changer', WLQuantityChanger);

class WLDeleteItem extends HTMLElement {
  constructor(){
    super();
    this.addEventListener('click', (e) => {
      this.deleteItem(e.target.dataset.key, 0)
    })
  }
  deleteItem(key, quantity) {
    const data = {
      updates: {
        [key]: quantity
      },
      sections: WLCartDomRenderElements().map((section) => section.id),
      section_url: location.href
    };
    data.updates[key] = quantity;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then((response) => {
      return response.json();
    })
    .then((state) => {
      WLCartDomRenderElements().forEach((wlDomRenderElement) => {
          WLDomRender(wlDomRenderElement.section, state.sections[wlDomRenderElement.section], document.querySelector(`[data-id="${wlDomRenderElement.id}"]`) ,wlDomRenderElement.target);
      });
    });
  }
}
customElements.define('wl-delete-item', WLDeleteItem);


class WLOutOfStookButton extends HTMLElement {
  constructor(){
    super();
    this.closeEvt();
    this.modal = this.closest('#backInStockMailer')
    this.addEventListener('click', (e) => {
      
      const modal = this.closest('#backInStockMailer')
      const emailAddress = modal.querySelector('input').value
      const variantId = this.dataset.variantId
      const productId = this.dataset.productId
      this.backInStockSendMail(emailAddress, variantId, productId, false, modal)
    })
  }
  closeEvt(){
    const modal = this.closest('#backInStockMailer')
    const closeBtns = modal.querySelector('[data-close]')
    closeBtns.addEventListener('click', () => {
      modal.classList.remove('active')
      modal.classList.add('hidden')
    })
  }
  set(target){
    const modal = this.closest('#backInStockMailer')
    this.dataset.variantId = target.dataset.variantId
    this.dataset.productId = target.dataset.productId
    modal.querySelector('input[type="email"]').value = this.dataset.customerEmail
    modal.querySelector('.error').innerHTML = ''
  }
  open(){
    this.modal.classList.add('active')
    this.modal.classList.remove('hidden')
    this.modal.classList.remove('hidden')
  }
  close(){
    this.modal.classList.remove('active')
    this.modal.classList.add('hidden')
  }
  backInStockSendMail(emailAddress, variantId, productId, customer){
    const modal = this.closest('#backInStockMailer')
    BIS.create(
      emailAddress, variantId, productId
    ).then(function(resp) {
      if(resp.status == 'OK'){
        modal.querySelector('.error').innerHTML = ''
        alert('再入荷通知を設定しました')
        modal.classList.remove('active')
        modal.classList.add('hidden')
      } else {
        if(resp.errors.base == "You have already registered for a notification for that item."){
          modal.querySelector('.error').innerHTML = '既に再入荷通知が設定されています'
          return true
        }
      }
    })
  }
}

customElements.define('wl-out-of-stock-button', WLOutOfStookButton);
class WLAddToCartButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (e) => {
      if (!this.hasAttribute('disabled')) {
        if(this.dataset.available == 'true') {
          this.addProduct();
        } else if(this.dataset.backinstock == 'true') {
          alert('商品在庫がありません。')
        } else {
          const outOfStockButton = document.querySelector('wl-out-of-stock-button')
          outOfStockButton.set(e.target)
          outOfStockButton.open(e.target)
        }
      }
    });
  }
  addProduct() {
    console.log(WLCartDomRenderElements())
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          quantity: 1,
          id: this.dataset.variantId
        }],
        sections: WLCartDomRenderElements().map((section) => section.id),
        section_url: location.href
      }),
    })
      .then(response => response.json())
      .then(data => {
        this.dispatchEvent(new CustomEvent('wlAddToCartButton', {
          detail: {
            cart: data,
          },
        }));
        WLCartDomRenderElements().forEach((wlDomRenderElement) => {
          WLDomRender(wlDomRenderElement.section, data.sections[wlDomRenderElement.section], document.querySelector(`[data-id="${wlDomRenderElement.id}"]`) ,wlDomRenderElement.target);
        });
        window.innerWidth < 768 ? document.querySelector('#header-contents').classList.add('active') : document.querySelector('#header-contents').classList.remove('active')
        
        document.querySelector('#cart-modal-content').classList.add('active');
        document.querySelector('wl-cart-modal').classList.add('active');
        document.querySelector('wl-cart-modal').style.top = document.querySelector('#header-contents').clientHeight + 'px';
        document.querySelector('wl-cart-modal .modal-bg').style.top = document.querySelector('#header-contents').clientHeight + 'px';
        document.body.style.top = '-' + window.scrollY + 'px'
        document.body.classList.add('fixed')
      })
      .catch((error) => {
        console.error(error);
      });
  }
}
customElements.define('wl-add-to-cart-button', WLAddToCartButton);

class WLRecentryViewedProducts extends HTMLElement {
  constructor() {
    super();
    if (this.dataset.template.includes('product')) {
      this.fetchEvt()
      this.addProduct(this.dataset.productId);
    } else {
      this.fetchEvt()
    }
    window.addEventListener('resize', () => {
      if(this.dataset.noSlider == 'true' && window.innerWidth > 767) {
        this.dataset.noSlider = ''
        this.fetchEvt()
      } else if(window.innerWidth > 767) {
        this.dataset.noSlider = ''
        if(!this.querySelector('.swiper-notification')) {
          this.fetchEvt()
        }
      } else {
        
        if(this.querySelector('.swiper-notification') && this.dataset.noSlider == '') {
          this.fetchEvt()
        }
        this.dataset.noSlider = true
      }
    })
  }
  getProuducts() {
    let products = JSON.parse(localStorage.getItem('recentryViewedProducts') ? localStorage.getItem('recentryViewedProducts') : '[]');
    products = products.filter(v => v)
    return products;
  }
  addProduct(product) {
    const products = this.getProuducts();
    // 配列の重複を削除
    const removals = [product];
    const uniqueProducts = products.filter(function(v){
      return ! removals.includes(v);
    });
    
    // 先頭に追加
    uniqueProducts.unshift(product);
    
    // limit以上の場合は削除
    if (uniqueProducts.length > parseInt(this.dataset.limit)) {
      uniqueProducts.pop();
    }
    localStorage.setItem('recentryViewedProducts', JSON.stringify(uniqueProducts));
  }
  fetchEvt(){
    const products = this.getProuducts();
    const aaa = 'id:' + products.join(',').replaceAll(',', ' OR id:');
    return new Promise( (resolve, reject ) => {
      fetch('/search?view=recentry-viewed' + '&options[prefix]=last&type=product&q=id:' + products.join(',').replaceAll(',', ' OR id:'))
      .then(response => response.text())
      .then(text => {
        // console.log(text);
        const parser = new DOMParser();
        const htmlDocument = parser.parseFromString(text, 'text/html');
        const productsUL = htmlDocument.querySelector('ul.swiper-wrapper');
        
        const productCount = productsUL.querySelectorAll('li.swiper-slide')
        function mySort(myUL, myNodeList) {
          // (2) 配列を得る
          var myArray = Array.prototype.slice.call(myNodeList);
          // (3) 配列をソート
          function compareText (a,b) {
            if (parseInt(a.dataset.index) > parseInt(b.dataset.index))
                return 1;
            else if (parseInt(a.dataset.index) < parseInt(b.dataset.index))
                return -1;
            return 0;
          }
          myArray.sort(compareText);
          // (4) 新しい順番を DOM ツリーに反映
          
          for (var i=0; i<myArray.length; i++) {
            myUL.appendChild(myUL.removeChild(myArray[i]))
          }
        }
        for (let productLI of productCount) {
          if(products.length > 0) {
            for(let index in products) {
              if(products[index] == parseInt(productLI.dataset.productId)) {
                productLI.dataset.index = parseInt(index) + 1;
              }
            }
          }
        }
        
        mySort(productsUL, productCount)
        if(productCount && productCount.length > 0) {
          this.querySelector('.swiper').innerHTML = productsUL.outerHTML;
          if(productCount.length > 4 && window.innerWidth > 767) {
            const swiper = new Swiper('wl-recentry-viewed-products .swiper', {
              loop: true,
              slidesPerView: 3,
              navigation: {
                nextEl: 'wl-recentry-viewed-products .swiper-button-next',
                prevEl: 'wl-recentry-viewed-products .swiper-button-prev'
              },
              breakpoints: {
                // スライドの表示枚数：500px以上の場合
                900: {
                  slidesPerView: 4,
                }
              }
            });
          } else {
            this.dataset.noSlider = true;
          }
          
        } else {
          this.innerHTML = '<div>閲覧履歴はありません。</div>';
        }
      });
    });
  }
}
customElements.define('wl-recentry-viewed-products', WLRecentryViewedProducts);

// TODO: カラーピッカーのエレメント適用
class WLColorPicker extends HTMLElement {
  constructor(){
    super();
    this.targets = this.querySelectorAll('input[type="radio"]')
    this.targets.forEach(target => {
      target.addEventListener('change', e => {
        this.dataset.variantId = e.target.dataset.variantId
        this.colorChange(e)
        this.priceChange(e)
        /**
         * assign compare_at_price = product.selected_or_first_available_variant.compare_at_price
          assign price = product.selected_or_first_available_variant.price
          assign discount = compare_at_price | minus: price
          assign discount_parcent = discount | times : 100 | divided_by : product.selected_or_first_available_variant.compare_at_price
         */
        const compareAtPrice = parseInt(e.target.dataset.comparePrice)
        const price = parseInt(e.target.dataset.price)
        const discount = compareAtPrice - price
        const discountParcent = Math.floor((discount / compareAtPrice) * 100)
        this.closest('.product-content').querySelector('.collection-product-discount-on-image > span').innerHTML = discountParcent.toFixed(0)
      })
    })
  }
  colorChange(e){
    const elements = {
      'addToCart': this.closest('.product-content').querySelector('wl-add-to-cart-button')
    }
    // カラーの適用
    elements.addToCart.dataset.variantId = e.target.dataset.variantId
    elements.addToCart.dataset.available = e.target.dataset.available
    if(e.target.dataset.available == 'false' && e.target.dataset.backinstock == 'true' ) {
      elements.addToCart.querySelector('.text').innerHTML = 'SOLD OUT'
      elements.addToCart.querySelector('.cart').classList.add('hidden')
      elements.addToCart.querySelector('.bell').classList.add('hidden')
    } else if(e.target.dataset.available == 'false' && e.target.dataset.backinstock == 'false') {
      elements.addToCart.querySelector('.cart').classList.add('hidden')
      elements.addToCart.querySelector('.bell').classList.remove('hidden')
      elements.addToCart.querySelector('.text').innerHTML = '再入荷通知'
    } else {
      elements.addToCart.querySelector('.cart').classList.remove('hidden')
      elements.addToCart.querySelector('.bell').classList.add('hidden')
      elements.addToCart.querySelector('.text').innerHTML = 'カートに入れる'
    }

    elements.addToCart.dataset.variantId = e.target.dataset.variantId
    // カラー名の適用
    this.closest('.product-content').querySelector('.color-name').innerHTML = e.target.value
    // 画像変更
    if(e.target.dataset.variantImage) {
      this.closest('.product-content').querySelector('img').setAttribute('src', e.target.dataset.variantImage)
    }
    //リンク先の適用
    const variantHref = this.closest('.product-content').querySelector('.more-view a').href;
    const variantSelectHref = variantHref.replace(/variant=\d+/, `variant=${e.target.dataset.variantId}`).replace(/%27/g, '');
    this.closest('.product-content').querySelector('.more-view a').href = variantSelectHref;
    this.closest('.product-content').querySelector('.collection-product-img-wrap').setAttribute('onclick', `location.href='${variantSelectHref}'`)

  }
  priceChange(e){
    // 価格の適用
    this.closest('.product-content').querySelector('.price-wrap .price').innerHTML = 
      e.target.dataset.price ? (parseInt(e.target.dataset.price) / 100).toLocaleString() + '円' : ''
    // 割引価格の適用
    this.closest('.product-content').querySelector('.price-wrap .compare_at_price s').innerHTML = 
      e.target.dataset.comparePrice ? (parseInt(e.target.dataset.comparePrice) / 100).toLocaleString() + '円' : ''
  }
}
customElements.define('wl-color-picker', WLColorPicker)
class WLProductAccesories extends HTMLElement {
  constructor(){
    super();
    this.fetchEvt()
    window.addEventListener('resize', () => {
      if(this.dataset.noSlider == 'true' && window.innerWidth > 767) {
        this.dataset.noSlider = ''
        this.fetchEvt()
      } else if(window.innerWidth > 767) {
        this.dataset.noSlider = ''
        if(!this.querySelector('.swiper-notification')) {
          this.fetchEvt()
        }
      } else {
        
        if(this.querySelector('.swiper-notification') && this.dataset.noSlider == '') {
          this.fetchEvt()
        }
        this.dataset.noSlider = true
      }
    })
    
  }
  fetchEvt(){
    return new Promise((resolve, reject) => {
      fetch(`/search?view=accesories&type=product&q=${encodeURI('tag:"SA_' + this.dataset.productHandle + '" AND product_type:"アクセサリー"')}&options%5Bprefix%5D=last`)
      .then(res => res.text())
      .then(text => {
        const parser = new DOMParser();
        const htmlDocument = parser.parseFromString(text, 'text/html');
        const productsUL = htmlDocument.querySelector('ul');
        const productCount = productsUL.querySelectorAll('li')
        
        if(productCount && productCount.length > 0) {
          this.querySelector('.swiper').innerHTML = productsUL.outerHTML;
          if(productCount.length > 4 && window.innerWidth > 767) {
            const swiper = new Swiper('wl-product-accesories .swiper', {
              loop: true,
              slidesPerView: 3,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
              },
              breakpoints: {
                // スライドの表示枚数：500px以上の場合
                900: {
                  slidesPerView: 4,
                }
              }
            });
          } else {
            this.dataset.noSlider = true;
          }
          
        } else {
          this.innerHTML = '<div>閲覧履歴はありません。</div>';
        }
      })
    })
  }
}
customElements.define('wl-product-accesories',WLProductAccesories)


class WLCollectionBanner extends  HTMLElement {
  constructor(){
    super();
    const sectionId = this.dataset.sectionId
    const section = '#shopify-section-' + sectionId
    const slideCount = this.querySelectorAll('.swiper-slide').length
    const swiper = new Swiper(section + ' wl-collection-banner', {
            centeredSlides: true,
            initialSlide: 1,
            loop: true,
            spaceBetween: 10,
            speed: 600,
            slidesPerView: slideCount > 1 ? 1.25 : 1,
            direction: 'horizontal',
            // effect: 'coverflow',
            autoplay: {
              delay: 5000,
              disableOnInteraction: false,
            },
            navigation: {
              nextEl: `${section} .swiper-button-next`,
              prevEl: `${section} .swiper-button-prev`
            },
            breakpoints: {
              // スライドの表示枚数：500px以上の場合
              900: {
                centeredSlides: false,
                loop: true,
                spaceBetween: 20,
                slidesPerView: 2,
              }
            }
          });
  }
}
customElements.define('wl-collection-banner', WLCollectionBanner);